
import { useEffect, useRef, useState } from "react";
import { Alert, Button, Container, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import styles from "./style.module.scss"
import cx from "classnames";
import DefaultOffCanvas, { DefaultOffCanvasProps } from "../DefaultOffCanvas";
import { OpenDocumentExemptionPubSub, OpenDocumentExemptionPubSubPayload, OpenUpgradePlanPubSub } from "@utils/pubsubs/PubSub";
import { ProductExemptionDataType } from "@/formTypes/ProductExemptionDataType";
import AddExemptionForm from "@components/forms/AddExemptionForm";
import useFeatureAccess from "@/hooks/useFeatureAccess";

type DocumentExemptionOffCanvasProps = {
    onAddExemption: (exemptionChange?: ProductExemptionDataType) => void
} & DefaultOffCanvasProps

const DocumentExemptionOffCanvas = (props: DocumentExemptionOffCanvasProps) => {
    const { btnColor = "primary", className, onAddExemption } = props;
    const [defaultData, setDefaultData] = useState<Partial<ProductExemptionDataType>>({});
    const [isOpen, setOpen] = useState(false);
    const { hasFeature } = useFeatureAccess();

    // Ref para que el callback del PubSub (suscrito una sola vez) lea el valor vigente
    const hasFeatureRef = useRef(hasFeature);
    useEffect(() => { hasFeatureRef.current = hasFeature; }, [hasFeature]);

    useEffect(() => {
        const unsubscribe = OpenDocumentExemptionPubSub.subscribe(openOffCanvas);
        return () => {
            unsubscribe();
        };
    }, []);

    const openOffCanvas = async (payload: OpenDocumentExemptionPubSubPayload) => {
        // Gating por plan: cubre todos los disparadores de exoneración en un solo punto
        if (!hasFeatureRef.current("action:exemption:apply")) {
            OpenUpgradePlanPubSub.publish({ featureLabel: "Exoneraciones", featureId: "action:exemption:apply" });
            return;
        }
        const { openOffCanvas = false, defaultData = {}, productId, lineSubtotal } = payload;
        const initialValues = {
            ...defaultData,
            productId,
            lineSubtotal
        }
        setOpen(openOffCanvas);
        setDefaultData(initialValues || {} as ProductExemptionDataType);
    }

    const toogleOffCanvas = (newState: boolean) => {
        if (newState && !hasFeature("action:exemption:apply")) {
            OpenUpgradePlanPubSub.publish({ featureLabel: "Exoneraciones", featureId: "action:exemption:apply" });
            return;
        }
        setOpen(newState);
        if (newState == false) {
            onCanvasClosed();
        }
    }

    const onCanvasClosed = () => {
        setOpen(false);
    }

    const triggerOnAddExemption = (exemptionData?: ProductExemptionDataType) => {
        setOpen(false);
        if (onAddExemption) {
            onAddExemption(exemptionData)
        }
    }

    return (
        <>
            {props.children && (<Button
                color={btnColor}
                type="button"
                className={cx([className, styles.button])}
                onClick={() => toogleOffCanvas(!isOpen)}
            >
                {props.children}
            </Button>
            )}
            <DefaultOffCanvas
                className={styles.offCanvas}
                direction="end"
                isOpen={isOpen}
                onClosed={onCanvasClosed}
                toggle={() => toogleOffCanvas(!isOpen)}
            >
                <OffcanvasHeader className={styles.offCanvasHeader} toggle={onCanvasClosed}>
                    Agregar Informacion de Exoneracion
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Container>
                        <Alert className="mb-4" color="warning">
                            Por favor proporcione la información necesaria para realizar la exoneracion
                        </Alert>
                        <AddExemptionForm
                            defaultData={defaultData}
                            onAddExemption={triggerOnAddExemption}
                        />
                    </Container>
                </OffcanvasBody>
            </DefaultOffCanvas >
        </>
    );
}
export default DocumentExemptionOffCanvas;
